import React from "react";
import "./preneed-booking-status.scss";

const statusColors: { [key: string]: string } = {
    "Pending": "status-pending",
    "Confirmed": "status-approved",
    "Paid": "status-approved",
    "Cancelled": "status-rejected",
    "Completed": "status-paid",
    "Primary": "status-primary",
    "Secondary": "status-secondary"
};

const PreneedBookingStatus: React.FC<{ status: string }> = ({ status }) => {
    return (
        <span
            className={`preneed-status-badge  preneed-${statusColors[status]} table-cell-ellipsis`}
        >
            {status}
        </span>
    );
};

export default PreneedBookingStatus;

